/**
 * Ohlásí backendu, odkud návštěvník přišel.
 *
 * Klasifikaci kanálu dělá backend (TouchResolver) — tady se jen posbírají surová
 * data. Odesílají se pouze whitelistované parametry, aby se do API nedostal celý
 * query string, který může obsahovat osobní údaje.
 *
 * Server drží výsledek v šifrované HttpOnly cookie `bt_attr` (90 dní) a při
 * registraci nebo poptávce si ji přečte sám — formuláře se o atribuci nestarají.
 */

const TRACKED_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'wbraid',
    'gbraid',
];

const SESSION_GUARD_KEY = 'bt_attr_sent';

const collectParams = (search : string) : Record<string, string> => {
    const query = new URLSearchParams(search);
    const params : Record<string, string> = {};

    TRACKED_PARAMS.forEach((key) => {
        const value = query.get(key);

        if (value) {
            params[key] = value.slice(0, 255);
        }
    });

    return params;
};

export const reportTouch = () : void => {
    try {
        if (typeof window === 'undefined') {
            return;
        }

        if (window.sessionStorage.getItem(SESSION_GUARD_KEY)) {
            return;
        }

        window.sessionStorage.setItem(SESSION_GUARD_KEY, '1');

        const body = JSON.stringify({
            params: collectParams(window.location.search),
            path: window.location.pathname.slice(0, 255),
            referrer: document.referrer.slice(0, 255),
        });

        // Fire-and-forget: atribuce nikdy nesmí zdržet ani rozbít stránku.
        // Cesta /visit je schválně neutrální — "attribution"/"track" v URL blokují adblockery.
        fetch(`${process.env.NEXT_PUBLIC_API_URL}/v1/visit`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body,
            keepalive: true,
        }).catch(() => undefined);
    } catch (err) {
        console.warn('[attribution] failed:', err);
    }
};
